var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .xls-style-0 {\n      fill: #185C37;\n    }\n\n    .xls-style-1 {\n      fill: #21A366;\n    }\n\n    .xls-style-2 {\n      fill: #107C41;\n    }\n\n    .xls-style-3 {\n      opacity: 0.1;\n      enable-background: new;\n    }\n\n    .xls-style-4 {\n      opacity: 0.2;\n      enable-background: new;\n    }\n\n    .xls-style-5 {\n      fill: url(#SVGID_1_);\n    }\n\n    .xls-style-6 {\n      fill: #FFFFFF;\n    }\n\n    .xls-style-7 {\n      fill: #33C481;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-0",
    d: "M321.49,244.09l-202.42-35.72v263.94c0,12.05,9.77,21.83,21.83,21.83l0,0h349.28 c12.05,0,21.83-9.77,21.83-21.83l0,0v-97.24L321.49,244.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-1",
    d: "M321.49,17.86H140.9c-12.05,0-21.83,9.77-21.83,21.83l0,0v97.24L321.49,256l107.16,35.72L512,256V136.93 L321.49,17.86z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-2",
    d: "M119.07,136.93h202.42V256H119.07V136.93z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-3",
    d: "M263.94,113.12H119.07v297.67h144.87c12.04-0.04,21.79-9.79,21.83-21.83V134.94 C285.73,122.9,275.98,113.16,263.94,113.12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-4",
    d: "M252.04,125.02H119.07V422.7h132.97c12.04-0.04,21.79-9.79,21.83-21.83V146.85 C273.82,134.81,264.07,125.06,252.04,125.02z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-4",
    d: "M252.04,125.02H119.07v273.86h132.97c12.04-0.04,21.79-9.79,21.83-21.83V146.85 C273.82,134.81,264.07,125.06,252.04,125.02z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-4",
    d: "M240.13,125.02H119.07v273.86h121.06c12.04-0.04,21.79-9.79,21.83-21.83V146.85 C261.91,134.81,252.17,125.06,240.13,125.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.5065,
    y1: -1464.0308,
    x2: 216.4467,
    y2: -1167.9695,
    gradientTransform: "matrix(1 0 0 1 0 1572)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#18884F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#117E43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B6631"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-5",
    d: "M21.83,125.02h218.3c12.05,0,21.83,9.77,21.83,21.83v218.3c0,12.05-9.77,21.83-21.83,21.83H21.83 C9.77,386.98,0,377.21,0,365.15v-218.3C0,134.79,9.77,125.02,21.83,125.02z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-6",
    d: "M67.6,326.94l45.91-71.14l-42.07-70.75h33.84l22.96,45.25c2.12,4.3,3.57,7.49,4.36,9.6h0.3 c1.51-3.43,3.1-6.76,4.76-9.99l24.54-44.83h31.07l-43.14,70.33l44.23,71.54H161.3l-26.52-49.66c-1.25-2.11-2.31-4.33-3.17-6.63 h-0.39c-0.78,2.25-1.81,4.41-3.07,6.43l-27.3,49.87L67.6,326.94L67.6,326.94z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-7",
    d: "M490.17,17.86H321.49v119.07H512V39.69C512,27.63,502.23,17.86,490.17,17.86L490.17,17.86z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "xls-style-2",
    d: "M321.49,256H512v119.07H321.49V256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/XLS-Icon.1ec30f77d8a418b55d1d474b51727e79.svg";
export { ForwardRef as ReactComponent };